import './App.css';
import { Route,Routes,useNavigate } from 'react-router-dom';
import Home from './Home.js';
import HeaderNav from './HeaderNav.js';
import Users from './UserManagement/Users.js';
import Reports from './Reports/Reports.js';
import Peers from './Peers/Peers.js';
import Login from './Login.js';
import { useState,useEffect } from 'react';
import axios from 'axios';
import EditUsers from './UserManagement/EditUsers.js';
import ResetPassword from './sign-in/ResetPassword.js';
import Financials from './Financials/Financials.js';
import AdminReports from './Reports/AdminReports.js';
import AdminEdit from './Financials/AdminEdit.js';
import ReportsHistorical from './Reports/ReportsHistorical.js';
import EditCompanies from './Admin/EditCompanies.js';
function App() {
  
  // Version for cache busting - update this for each rollout
  const APP_VERSION = '2.0.0';
  
 //Token Setup
 const [token, setToken] = useState('');
  const [allCompanies,setAllCompanies] = useState({});
  const [admin,setAdmin]=useState(false);

  // Function to clear all data on logout
  const clearAllData = () => {
    console.log('Clearing all data...');
    console.log('Token before clear:', token);
    setToken('');
    setAllCompanies({});
    setAdmin(false);
    console.log('Data cleared, token should now be empty');
  };

  // Function to force cache refresh (can be called separately if needed)
  const forceCacheRefresh = () => {
    // Clear browser cache if available
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Force reload with cache busting
    const timestamp = new Date().getTime();
    window.location.href = `/login?v=${APP_VERSION}&t=${timestamp}`;
  };


 function refreshCompanies(){
  axios({
      // Endpoint to send files
      url: process.env.REACT_APP_API_URL+'Company',
      method: "Get",
      data:{  },
      }).then((res) => {
          setAllCompanies(res.data);       
          console.log("Companies are set");   
      }).catch((err) => {
          console.log(err)
      });
}


 // Load value from localStorage on component mount
 useEffect(() => {
  try{
    //it's possible I won't be able to access this, so I need to revert to login if I can't
   const storedToken = localStorage.getItem('jwtToken');
   if (storedToken) {
      setToken(storedToken);
      // Don't call refreshCompanies here - wait for successful login
   }else{
    navigate('/login');
   }
  }catch(ex)
  {
    navigate('/login');
  }
 }, []);

 // Update localStorage whenever token changes
 useEffect(() => {
  //token===null||token===undefined||token===""?console.log("Setting Token null"):console.log("valid set");
  if(token!==null&&token!==undefined && token!=="")
  {
   localStorage.setItem('jwtToken', token);
   axios.defaults.headers.common['Authorization']='Bearer '+token;
   axios.defaults.headers.post['Content-Type']='application/json';
   // Load companies when token is set (either from login or from localStorage)
   if(allCompanies===null||allCompanies===undefined||Object.keys(allCompanies).length===0)
   {
    refreshCompanies();
   }
  }
 }, [token]);

//  Axios interceptor to log out if invalid token
 axios.interceptors.response.use(response => {
  return response;
}, error => {
 if (error.response.status === 401) {
  setToken("");
  navigate('/login');
 }
 return error;
});


const navigate = useNavigate();

  return (
    <div className="gridContainer">
    
      <Routes>
        <Route path="/" element={<HeaderNav token={token} setToken={setToken} isAdmin={admin} clearAllData={clearAllData}></HeaderNav>}>
          <Route index element={<Home />} />
          <Route path="reports" element={<Reports />} />
          <Route path="users" element={<Users allCompanies={allCompanies} setAllCompanies={setAllCompanies}></Users>} />
          <Route path="peers" element={<Peers setAllCompanies={setAllCompanies} allCompanies={allCompanies} />} />
          <Route path="login" element={<Login token={token} setToken={setToken} admin={admin} setAdmin={setAdmin} refreshCompanies={refreshCompanies}></Login>} />
          <Route path="editUsers" element={<EditUsers allCompanies={allCompanies}></EditUsers>}></Route>
          <Route path="resetPassword" element={<ResetPassword></ResetPassword>}></Route>
          <Route path="financials" element={<Financials/>}></Route>
          <Route path="adminReports" element={<AdminReports/>}></Route>
          <Route path="adminEdit" element={<AdminEdit allCompanies={allCompanies}></AdminEdit>}></Route>
          <Route path="editCompanies" element={<EditCompanies allCompanies={allCompanies} setAllCompanies={setAllCompanies} refreshCompanies={refreshCompanies}></EditCompanies>}></Route>
          <Route path="historical" element={<ReportsHistorical/>}></Route>
          {/* <Route path="*" element={<NoPage />} /> */}
        </Route>
        
      </Routes>
    
    </div>
  );
}

export default App;
